import React, { useState } from "react";
import "./styles.scss";
import { ReactComponent as GridView } from "../../../../public/icons/ViewType/gridView.svg";
import { ReactComponent as GridViewSelected } from "../../../../public/icons/ViewType/gridViewSelected.svg";
import { ReactComponent as ListView } from "../../../../public/icons/ViewType/listView.svg";
import { ReactComponent as ListViewSelected } from "../../../../public/icons/ViewType/listViewSelected.svg";

export default ({ onSwitchView }) => {
  const [view, setViewType] = useState("list");
  const switchView = view => {
    setViewType(view);
    onSwitchView(view);
  };

  return (
    <div className="view-type d-flex justify-content-end py-3 pr-2">
      {view === "list" ? (
        <ListViewSelected />
      ) : (
        <ListView onClick={() => switchView("list")} />
      )}
      {view === "grid" ? (
        <GridViewSelected />
      ) : (
        <GridView onClick={() => switchView("grid")} />
      )}
    </div>
  );
};
